import {request, requestWithKey} from "@/utils/request";
import endpoint from "@/config/endpoint";

export default {
  getStoreCode: async(payload) => {
    try {
      const res = await request.get(`${endpoint.STORE_REGISTRATION.FIND_STORE_CODE.GET}/${payload}`);
      if (res) {
        return res.data;
      } else {
        throw res;
      }
    } catch (e) {
      return e;
    }
  },
  getMemberCheck: async(payload) => {
    try {
      const res = await requestWithKey.get(`${endpoint.STORE_REGISTRATION.MEMBER.CHECK.GET}?email=${payload}`);
      if (res) {
        return res.data;
      } else {
        throw res;
      }
    } catch (e) {
      return e;
    }
  },
  getMemberDetail: async(payload) => {
    try {
      const res = await requestWithKey.get(`${endpoint.STORE_REGISTRATION.DETAIL.GET}/${payload}`);
      if (res) {
        return res.data;
      } else {
        throw res;
      }
    } catch (e) {
      return e;
    }
  },
  postVerifyEmailOTP: async(payload) => {
    try {
      const res = await requestWithKey.post(`${endpoint.STORE_REGISTRATION.EMAIL.VERIFICATION.POST}`, payload);
      if (res) {
        return res.data;
      } else {
        throw res;
      }
    } catch (e) {
      return e;
    }
  },
  postMemberRegistration: async(payload) => {
    try {
      const res = await requestWithKey.post(`${endpoint.STORE_REGISTRATION.MEMBER.POST}`, payload);
      if (res) {
        return res.data;
      } else {
        throw res;
      }
    } catch (e) {
      return e;
    }
  },
}